module.exports = __webpack_public_path__ + "/login_ui/img/qa-b45116a3b73940abd197623e466c4030.svg";